import type { Crumb } from 'features/Breadcrumbs/hooks/useBreadcrumbs/hooks/useCrumbs/types';

export const createCrumb = (
  title: string,
  pathname: string,
  isLoading: boolean = false,
): Crumb => ({
  title,
  to: pathname,
  isLoading,
});
